import React from 'react'
import OrderIndicator from 'components/OrderIndicator'
import { MdContentCopy } from "react-icons/md"
import { toast } from "react-toastify"
import moment from 'moment'
import 'moment/locale/tr'

moment.locale("tr");


const Payouts = ({ data }) => {
  const handleCopy = (text, fieldName) => {
    navigator.clipboard.writeText(text);
    toast.success(`${fieldName} kopyalandı`);
  };

  return (
    <div className="overflow-x-auto p-4">
      <table className="min-w-full divide-y-2 divide-gray-200 text-sm">
        <thead className="">
          <tr>
            <th className="whitespace-nowrap text-left px-4 py-2 font-medium text-white-100">
              Tutar
            </th>

            <th className="whitespace-nowrap text-left px-4 py-2 font-medium text-white-100">
              Hesap Sahibi
            </th>
            <th className="whitespace-nowrap text-left px-4 py-2 font-medium text-white-100">
              İban
            </th>
            <th className="whitespace-nowrap text-left px-4 py-2 font-medium text-white-100">
              İşlem Tarihi
            </th>
            <th className="whitespace-nowrap text-left px-4 py-2 font-medium text-white-100">
              İşlem Durumu
            </th>

          </tr>
        </thead>

        <tbody className="divide-y divide-gray-200">
          {data?.map((data) => (
            <tr key={data.id}>
              <td className="whitespace-nowrap px-4 py-2 font-medium text-white-100">
                {
                    Intl.NumberFormat("tr-TR", {
                        style: "currency",
                        currency: "TRY",
                    }).format(data.amount_try)
                }
              </td>

              <td className="whitespace-nowrap px-4 py-2 text-white-100">
                <div className="flex items-center gap-2">
                  {data.holder_name}
                  <MdContentCopy 
                    className="cursor-pointer text-primary hover:text-primary-dark" 
                    onClick={() => handleCopy(data.holder_name, "Ad Soyad")}
                  />
                </div>
              </td>
              <td className="whitespace-nowrap px-4 py-2 text-white-100">
                <div className="flex items-center gap-2">
                  {data.iban}
                  <MdContentCopy 
                    className="cursor-pointer text-primary hover:text-primary-dark" 
                    onClick={() => handleCopy(data.iban, "İban")}
                  />
                </div>
              </td>
              <td className="whitespace-nowrap px-4 py-2 text-white-100">
                {moment(data.created_at).format('Do MMMM YYYY, H:mm:ss')}
              </td>
              <td className="whitespace-nowrap px-4 py-2 text-white-100">
                {data.status === "completed" ? (
                  <OrderIndicator color="green">Aktarım Yapıldı.</OrderIndicator>
                ) : data.status === "pending_transfer" ? (
                  <OrderIndicator color="yellow">Aktarım Bekliyor.</OrderIndicator>
                ) : data.status === "failed" ? (
                  <OrderIndicator color="red">
                    Aktarım Reddedildi.
                  </OrderIndicator>
                ) : (
                  <OrderIndicator color="red">No Data</OrderIndicator>
                )}
              </td>

            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Payouts;
